import { useEffect, useContext, useState } from 'react';
import ScrollContainer from 'react-indiana-drag-scroll';

import { DataContext } from 'providers/data';

import { ParamsCustomerCars } from 'utils/typeServices';

import { Typography, Box, Skeleton } from '@mui/material';
import NavTitle from 'components/views/NavTitle';
import FadeAnimation from 'components/views/FadeAnimation';

import { ContentCarrousel, ItemList, CardCar } from './styles';

import CarCard from 'assets/images/car-card.png';

const SkeletonAnimation = () => {
    return (
        <Skeleton animation="wave" variant="rounded" sx={{ width: '100%', height: '90px', borderRadius: '7.6285px 7.6285px 0 0' }} />
    )
}

const CarouselCars = () => {
    const listAnimation = [1, 2, 3, 4];
    const [listCarsUser, setListCarsUser] = useState<Array<ParamsCustomerCars>>([]);
    const { customerCars, selectedCar, blockClick, handleSelectedCar, handleGetCustomerCharges } = useContext(DataContext);

    const handleNewSelectedCar = (index: number) => {
        handleSelectedCar(listCarsUser[index]);

        handleGetCustomerCharges({
            token: localStorage.getItem('token')!,
            nrPlatform: listCarsUser[index].NR_PLATAFORMA
        });
    }

    useEffect(() => {
        if (customerCars) {
            setListCarsUser(customerCars);
        }
    }, [customerCars]);

    return (
        <Box>
            <Box sx={{
                display: 'flex',
                alignItems: 'end',
                justifyContent: 'space-between'
            }}>
                <NavTitle title='Veículo selecionado' />
                <Typography fontSize='.85rem' sx={{
                    paddingBottom: {
                        xs: '.35rem',
                        md: '0'
                    }
                }}>
                    {listCarsUser?.length > 0 &&
                        <>Total de veículos: <strong>{listCarsUser.length}</strong></>
                    }
                </Typography>
            </Box>
            <ContentCarrousel>
                <ScrollContainer className="scroll-container" style={{ cursor: listCarsUser?.length > 1 ? 'grab' : 'default' }}>
                    {listCarsUser.length > 0 ?
                        listCarsUser?.map(({ PLACA, NR_PLATAFORMA, NM_MODELO_BASICO, MODELO_ANO, CHASSI }, index) =>
                            <ItemList key={index} onClick={() => listCarsUser?.length > 1 && handleNewSelectedCar(index)} style={{ cursor: listCarsUser?.length > 1 ? 'pointer' : 'default' }}>
                                <FadeAnimation>
                                    <CardCar activeCar={selectedCar?.NR_PLATAFORMA === NR_PLATAFORMA ? 'active' : 'disabled'}>
                                        <img src={CarCard} alt="car card" />
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                textAlign: 'center',
                                                flexDirection: 'column',
                                                justifyContent: 'center'
                                            }}>
                                            <Typography
                                                color={selectedCar?.NR_PLATAFORMA === NR_PLATAFORMA ? 'white' : 'primary.main'}
                                                fontWeight={700}
                                                sx={{
                                                    fontSize: {
                                                        xs: '1.06rem',
                                                        md: '1.39rem'
                                                    },
                                                    overflow: 'hidden',
                                                    whiteSpace: 'nowrap',
                                                    maxWidth: '9.7rem',
                                                    textOverflow: 'ellipsis',
                                                }}>
                                                {PLACA ? PLACA : CHASSI}
                                            </Typography>
                                            <Typography
                                                color={selectedCar?.NR_PLATAFORMA === NR_PLATAFORMA ? 'white' : 'primary.main'}
                                                fontWeight={600}
                                                sx={{
                                                    fontSize: {
                                                        xs: '.5rem',
                                                        md: '.66rem'
                                                    }
                                                }}>
                                                {NM_MODELO_BASICO} - {MODELO_ANO}
                                            </Typography>
                                        </Box>
                                    </CardCar>
                                </FadeAnimation>
                            </ItemList>
                        )
                        : blockClick ?
                            <Box sx={{ display: 'flex', gap: '.625rem', margin: '0 auto' }}>
                                <Typography sx={{ fontSize: '1.25rem', fontWeight: 700, color: 'white', backgroundColor: 'primary.light', padding: '1.2rem 9px 4px', height: '3.375rem' }}>
                                    IMPORTANTE
                                </Typography>
                                <Typography sx={{ display: { xs: 'none', md: 'block' }, border: '1px solid #0AA8E3', fontWeight: 600, lineHeight: '1rem', padding: '.7rem 3.125rem 0', height: '3.375rem', fontSize: '.875rem', textAlign: 'center' }}>
                                    Não foi encontrada nenhuma plataforma com serviço <br />
                                    ativo para o usuário.
                                </Typography>
                                <Typography sx={{ display: { xs: 'block', md: 'none' }, border: '1px solid #0AA8E3', fontWeight: 600, lineHeight: '1rem', padding: '1.2rem .5rem 0', height: '3.375rem', fontSize: '.875rem', textAlign: 'center' }}>
                                    Nenhuma plataforma ativa.
                                </Typography>
                            </Box>
                            :
                            listAnimation.map((index) =>
                                <ItemList key={index}>
                                    <SkeletonAnimation />
                                </ItemList>
                            )
                    }
                </ScrollContainer>
            </ContentCarrousel>
        </Box>
    );
}

export default CarouselCars;